import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setReturnedItems } from "../../product/all-products/redux/Actions/paginationActions";
import "./style.css";
import { TrashIcon } from "@heroicons/react/24/outline";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";

export const ReturnedItems = ({ returnItemArray, returnTableRef }) => {
  const [activeRow, setActiveRow] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDeleteItem = (index) => {
    const updatedReturnItemArray = returnItemArray.filter((_, i) => i !== index);
    dispatch(setReturnedItems(updatedReturnItemArray));
  };

  //   useEffect(() => {
  //     const handleKeyDown = (event) => {
  //       if (event.key === "ArrowUp") {
  //         setActiveRow((prev) => (prev > 0 ? prev - 1 : prev));
  //       } else if (event.key === "ArrowDown") {
  //         setActiveRow((prev) => (prev < data.length - 1 ? prev + 1 : prev));
  //       } else if (event.key === "Enter") {
  //         setShowModal(true);
  //       }
  //     };

  //     window.addEventListener("keydown", handleKeyDown);
  //     return () => {
  //       window.removeEventListener("keydown", handleKeyDown);
  //     };
  //   }, [data.length]);

  return (
    <div>
      <p className="return-item-name">Returned Itemlist</p>
      <div className="return-details-container">
        <table ref={returnTableRef} className="custom-table no-outline" tabIndex={0}>
          <thead>
            <tr>
              <th className="table-small-column">Sn</th>
              <th colSpan={2}>Product</th>
              <th>Gtin</th>
              <th className="table-small-price">Mrp</th>
              <th className="table-small-price">Batch No</th>
              <th className="table-small-price">Selling Price</th>
              <th className="table-small-price">Original Qty</th>
              <th className="table-small-price">Returned Qty</th>
              <th className="table-small-delete"></th>
            </tr>
          </thead>
          <tbody className="custom-table-body">
            {returnItemArray.map((item, index) => (
              <tr
                key={item.id}
                // className={activeRow === index ? "return-active-row" : ""}
                onClick={() => setActiveRow(index)}
              >
                <td className="table-small-column">{index + 1}</td>
                <td className="product-name-column" colSpan={2}>
                  {item?.productName}
                </td>
                <td>{item.gtin}</td>
                <td className="table-small-price">{item?.mrp}</td>
                <td className="table-small-price">{item?.batchNo}</td>
                <td className="table-small-price">{item?.sellingPrice}</td>
                <td className="table-small-price">{item?.quantityBySpecs}</td>
                <td className="table-small-price">{item?.returnedQty}</td>
                <td className="table-small-column">
                  {/* <DeleteOutlineIcon onClick={() => handleDeleteItem(index)} /> */}
                  <PosCustomIcon
                    icon={<TrashIcon />}
                    height={"20px"}
                    width={"20px"}
                    pointer={true}
                    onClickFunction={() => handleDeleteItem(index)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
